import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Col, Divider, message, Row, Spin, Table } from 'antd';
import axios from '../../config/axios';
import moment from '../../config/moment';
import styles from './OrderInvoice.module.scss';

const OrderInvoice = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const id = searchParams.get('invoiceID');
    const isPrint = searchParams.get('print');
    const [order, setOrder] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.document.title = `Order Invoice - ${id}`;
        (async () => {
            try {
                const res = await axios.get(`/orders/${id}`);
                setOrder(res.data);
            } catch (error) {
                message.error('Invalid order ID');
                navigate('/');
            } finally {
                setLoading(false);
            }
        })();
    }, [id, navigate, isPrint]);

    useEffect(() => {
        if (isPrint) {
            setTimeout(() => {
                // window.print();
            }, 4000);
        }
    }, [isPrint]);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'title',
            render: (_, order) => `${order.title} ${order.tax_rate == 7.00 ? '(A)' : '(B)'}`
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'Unit Price',
            dataIndex: 'order_time_price',
            key: 'order_time_price',
            render: (_, order) => `€${order.order_time_price}`,
        },
        {
            title: 'Total Amount',
            dataIndex: 'total',
            key: 'total',
            render: (_, order) => '€' + (+order.order_time_price * +order.quantity + (2.5 * +order.order_time_price) / 100).toFixed(2),
        },
    ];

    const calculateOrderSubTotal = () => {
        let subTotal = 0.00;
        order.order_items.map(item => {
            subTotal = subTotal + (parseFloat(item.order_time_price) * item.quantity);
        })

        return parseFloat(subTotal).toFixed(2);
    }

    return (
        <div className={styles.wrapper}>
            {loading ? (
                <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
                    <Spin size='large' />
                </div>
            ) : (
                <>
                    <div className={styles.logo}>
                        <img src='/logo.svg' alt='logo' />
                    </div>
                    <Row gutter={[50, 20]}>
                        <Col span={12}>
                            <h2 className={styles.title}>Invoice</h2>
                            <Divider style={{ borderTop: '1px solid black', margin: '2px 0 1rem 0' }} />
                            <h3>Bill to: </h3>
                            <div>
                                <span className={styles.fw_6}>Name: </span> {order.title} {order.first_name} {order.last_name}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Address: </span> {order.house_no},{order.street_address},{order.state},{order.city}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Street, House Nr.: </span> {order.street_address},{order.house_no}
                            </div>
                            <div>
                                <span className={styles.fw_6}>City: </span> {order.city}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Postcode: </span> {order.zip_code}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Order Date: </span> {moment(order.timestamp).format('MMMM D, YYYY - LT')}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Delivery Date: </span> {order.delivery_date}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Customer Nr.: </span> {order.phone_number}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Invoice Nr.: </span> {order.id}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Payment status: </span> {order.payment_status}
                            </div>
                        </Col>
                        <Col span={12}>
                            <h3 className={styles.ship_to}>Ship to: </h3>
                            <div>
                                <span className={styles.fw_6}>Name: </span> {order.title} {order.first_name} {order.last_name}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Address: </span> {order.house_no},{order.street_address},{order.state},{order.city},
                                {order.country}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Street, House Nr.: </span> {order.street_address},{order.house_no}
                            </div>
                            <div>
                                <span className={styles.fw_6}>City: </span> {order.city}
                            </div>
                            <div>
                                <span className={styles.fw_6}>Postcode: </span> {order.zip_code}
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={24}>
                            <div className={styles.table}>
                                <Table
                                    footer={() => (
                                        <div className={styles.table_footer}>
                                            <div> <span className={styles.fw_6}>Sub Total: </span>  €{calculateOrderSubTotal()} </div>
                                            <div> <span className={styles.fw_6}>Delivery Charge: </span>  €{order.delivery_fee} </div>
                                            <div> <span className={styles.fw_6}>VAT A (7.00%): </span>  €{order.vat_a} </div>
                                            <div> <span className={styles.fw_6}>VAT B (19.00%): </span>  €{order.vat_b} </div>
                                            <div> <span className={styles.fw_6}>Order Total: </span>  €{order.total} </div>
                                        </div>
                                    )}
                                    rowKey='uid'
                                    bordered
                                    columns={columns}
                                    pagination={false}
                                    dataSource={order.order_items}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Divider style={{ borderTop: '1px solid black' }} />

                    <Row gutter={[20, 20]}>
                        <Col span={8}>
                            <div className={styles.footer_title}>Desi Fresh</div>
                            <div>Ust-IdNr. DE289327825 </div>
                            <div>
                                Tel : <a href='tel:+49-8161 5193561'>+49-8161 5193561</a>{' '}
                            </div>
                            <div>
                                Email : <a href='mailto:info@dfresh.de'>info@dfresh.de</a>{' '}
                            </div>
                            <div>
                                Website : <a href='http://dfresh.de'>dfresh.de</a>{' '}
                            </div>
                        </Col>
                        <Col span={8}>
                            <div className={styles.footer_title}>Bank Details </div>
                            <div>Deutsche Bank </div>
                            <div>IBAN: DE17700240896273000 </div>
                            <div>BIC Code: DETDEDBMUC </div>
                        </Col>
                        <Col span={8}>
                            <div className={styles.footer_title}>Address </div>
                            <div>Sonnenstraße 7a</div>
                            <div>85764 Oberschleißheim, Germany</div>
                            <div>Monday – Friday : 09:00 – 18:00</div>
                            <div>Saturday : 09:00 – 14:00</div>
                        </Col>
                    </Row>
                </>
            )}
        </div>
    );
};

export default OrderInvoice;
